<template>
  <div>
    <a-modal
      centered
      v-model="visible.AddModal"
      :title="title"
      width="1100px"
      :destroyOnClose="true"
      :maskClosable="false"
      @ok="onSubmit"
      :confirmLoading="visible.confirmLoading"
      :okButtonProps="{ props: { disabled: prohibit } }"
    >
      <a-spin :spinning="visible.spinning" tip="加载中...">
        <table>
          <tr>
            <td>
              <em style="color:#f00">*</em
              ><span class="label-txt" style="width: 70px;">代码 </span>
              <a-input :disabled="prohibit" v-model="roomPriceInfo.Code" />
            </td>
            <td>
              <em style="color:#f00">*</em
              ><span class="label-txt" style="width: 70px;">名称 </span>
              <a-input :disabled="prohibit" v-model="roomPriceInfo.Name" />
            </td>
            <td>
              <span class="label-txt">状态 </span>
              <a-select
                :disabled="prohibit"
                v-model="roomPriceInfo.ValidStatus"
                style="width: 40%"
              >
                <a-select-option value="1">启用</a-select-option>
                <a-select-option value="0">禁用</a-select-option>
              </a-select>
            </td>
            <td>
              <span class="label-txt">说明 </span>
              <a-input :disabled="prohibit" v-model="roomPriceInfo.Remark" />
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span class="label-txt">可用时段 </span>
              <a-time-picker
                class="time"
                v-model="roomPriceInfo.OffStartTime"
                placeholder="开始时间"
                format="HH:mm"
              />
              -
              <a-time-picker
                class="time"
                v-model="roomPriceInfo.OffEndTime"
                placeholder="结束时间"
                format="HH:mm"
              />
            </td>
            <td>
              <div style="margin-bottom: 3px;">
                <span class="label-txt">客户专用 </span>
                <a-checkbox
                  v-model="roomPriceInfo.IsCustomerUse"
                  @change="changeStatus($event, 1)"
                ></a-checkbox>
              </div>
            </td>
            <td>
              <div style="margin-bottom: 3px;">
                <span class="label-txt">会员专用 </span>
                <a-checkbox
                  v-model="roomPriceInfo.IsMemberUse"
                  @change="changeStatus($event, 2)"
                ></a-checkbox>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span class="label-txt">钟点房 </span>
              <a-checkbox
                :disabled="prohibit"
                :checked="roomPriceInfo.IsHourRoom"
                @change="onChangeHourRoom"
              ></a-checkbox>
              <span v-if="roomPriceInfo.IsHourRoom">
                <label style="margin-left:20px">时长：</label>
                <a-input-number
                  :min="0"
                  :max="24"
                  style="width:100px"
                  v-model="roomPriceInfo.Duration"
                  :disabled="prohibit"
                />
                小时
                <a-button
                  style="margin-left:20px"
                  type="primary"
                  size="small"
                  v-if="editId != ''"
                  @click="checkChargingStandard"
                  >超时收费标准</a-button
                >
              </span>
            </td>
            <td colspan="2">
              <div style="margin-bottom: 3px;">
                <span class="label-txt">默认价类 </span>
                <a-checkbox
                  :disabled="prohibit"
                  v-model="roomPriceInfo.IsDefault"
                ></a-checkbox>
              </div>
            </td>
            <!-- <td>
              <span class="label-txt">默认价类 </span>：
              <a-checkbox
                :disabled="prohibit"
                v-model="roomPriceInfo.IsDefault"
              ></a-checkbox>
            </td> -->
          </tr>
        </table>

        <a-divider orientation="left" class="divider">
          <a-icon type="picture" style="color:#1E90FF" />
          房价设置</a-divider
        >
        <div class="table room-table">
          <data-grid
            :columns="columns"
            v-model="data"
            bordered
            :props="{
              scroll: {
                x: columns.length * 120,
                y: false
              }
            }"
          >
          </data-grid>
        </div>
        <div style="margin-top:10px">
          <a-button type="primary" @click="addSpecialRoomPrice"
            >增加特殊房价</a-button
          >
          修改基础房价是否覆盖特殊房价：
          <a-radio-group v-model="isCoverPrice">
            <a-radio :value="1">
              是
            </a-radio>
            <a-radio :value="2">
              否
            </a-radio>
          </a-radio-group>
        </div></a-spin
      >
    </a-modal>

    <a-modal
      centered
      v-model="visible.priceCalendarModal"
      title="房价日历"
      width="1100px"
      @ok="onSubmitRoomPrice"
      @cancel="onCancel"
      :maskClosable="false"
      :destroyOnClose="true"
      :okButtonProps="{ props: { disabled: prohibit } }"
    >
      <div style="margin-top:10px;">
        <div style="text-align:right;">
          <a-radio-group
            v-model="selMonth"
            @change="onChangeMonth"
            buttonStyle="solid"
            style="float: left;"
          >
            日期:&nbsp;
            <a-radio-button
              v-for="(mon, index) in MonthButtonArr"
              :value="index"
              :key="mon.month"
              >{{ mon.month }}月</a-radio-button
            >
          </a-radio-group>
          <a-button
            type="primary"
            style="width:150px;margin-left:50px;"
            @click="openBatchEdit"
            :disabled="prohibit"
          >
            批量修改房价
          </a-button>
        </div>
        <!-- <a-table
          :columns="columnsRoomPrice"
          :dataSource="dataRoomPrice"
          bordered
          style="margin-top:20px;"
          :scroll="{ y: 450, x: this.tableLength }"
          :loading="visible.loading"
          :pagination="false"
          rowKey="Id"
          size="small"
        ></a-table> -->
        <DataGrid
          :columns="columnsRoomPrice"
          :data="dataRoomPrice"
          id="roomPriceTable"
          rowKey="Id"
          bordered
          style="margin-top:20px;"
          :props="{
            scroll: { y: 450, x: this.tableLength }
          }"
        >
        </DataGrid>
        <a-modal
          centered
          title="批量设置价格"
          v-model="visible.BatchEditModal"
          width="60%"
          :destroyOnClose="true"
          :maskClosable="false"
          @ok="onBatchEdit"
          :confirmLoading="visible.batchConfirmLoading"
        >
          <!-- 批量修改房价 -->
          <batchEditPrice
            :columns="columns"
            :data="dataRecord"
            :dateRange="this.columnsRoomPrice"
            ref="batchEditPrice"
          />
        </a-modal>

        <!-- 修改房价 -->
        <a-modal
          centered
          :maskClosable="false"
          :destroyOnClose="true"
          width="25%"
          v-model="visible.EditRoomPriceModal"
          title="修改房价"
          @ok="onEditRoomPrice"
        >
          <editRoomPrice
            ref="editRoomPrice"
            :roomInfo="roomInfoParams"
            :disable="prohibit"
          />
        </a-modal>
      </div>
    </a-modal>
    <ChargingStandard ref="ChargingStandard"></ChargingStandard>
  </div>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";
import moment from "moment";
import { cache } from "@/utils/common";
import batchEditPrice from "./BatchEditRoomPrice";
import editRoomPrice from "./EditRoomPrice";
import cloneDeep from "lodash/cloneDeep";
import ChargingStandard from "./ChargingStandard";
export default {
  name: "addRoomPrice",
  components: {
    DataGrid,
    batchEditPrice,
    editRoomPrice,
    ChargingStandard
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editId: "",
      prohibit: false,
      visible: {
        spinning: false,
        AddModal: false,
        confirmLoading: false,
        priceCalendarModal: false,
        BatchEditModal: false,
        EditRoomPriceModal: false,
        batchConfirmLoading: false
      },
      roomPriceInfo: {
        Code: "",
        Name: "",
        ValidStatus: "1",
        Attributes: 0,
        Remark: "",
        IsDefault: false,
        IsHourRoom: false,
        Duration: 0,
        IsCustomerUse: false,
        IsMemberUse: false,
        OffStartTime: null,
        OffEndTime: null
      },
      data: [], //基础房价数据
      dataRecord: {}, //记录当前的基础房价信息，当基础房价更改时，对比出改变的数据，更新房价日历
      columns: [],
      //以下是房价日历数据
      tableLength: "", //x轴横向滑动长度
      dataRoomPrice: [],
      columnsRoomPrice: [],
      MonthButtonArr: [], //获取三个月点击按钮
      selMonth: "",
      //特殊房价数据 包含三个月的
      monthData: [],
      //单独编辑房价参数
      roomInfoParams: {
        rowIndex: 0, //记录当时操作的行
        cellIndex: 0, //记录当时操作的列
        monthIndex: 0 //记录当时操作的月份
      },
      specialPrices: [],
      copyData: [],
      currentKey: 0,
      rowIndex: 0,
      isCoverPrice: 2
    };
  },
  created() {},
  mounted() {},
  methods: {
    checkChargingStandard() {
      this.$refs.ChargingStandard.show(this.editId);
    },
    changeStatus(e, status) {
      const val = e.target.checked;
      if (val) {
        const name = status == 1 ? "客户" : "会员";
        this.$info({
          title: "指定" + name + "专用的价类，普通订单将无法使用"
        });
      }
    },
    Show(value, id, prohibit, data) {
      this.selMonth = 0;
      this.isCoverPrice = 2;
      this.monthData = [];
      this.specialPrices = [];
      this.editId = id;
      this.data = [];
      this.copyData = [];
      this.currentKey = 0;
      this.rowIndex = 0;
      this.visible.spinning = true;
      this.visible.AddModal = true;
      this.prohibit = prohibit;
      if (value == 3) {
        //复制
        if (data) {
          this.setPriceData(data);
        }
        this.visible.spinning = false;
      } else if (this.editId == "") {
        this.roomPriceInfo.Code = "";
        this.roomPriceInfo.Name = "";
        this.roomPriceInfo.ValidStatus = "1";
        this.roomPriceInfo.Attributes = 0;
        this.roomPriceInfo.Remark = "";
        this.roomPriceInfo.IsDefault = false;
        this.roomPriceInfo.IsHourRoom = false;
        this.roomPriceInfo.IsCustomerUse = false;
        this.roomPriceInfo.IsMemberUse = false;
        this.roomPriceInfo.OffStartTime = moment("00:00", "HH:mm");
        this.roomPriceInfo.OffEndTime = moment("23:59", "HH:mm");
        this.roomPriceInfo.Duration = 0;
        this.$post("Get_Select_Items", { Types: "RoomType" })
          .then(res => {
            this.columns = res.Data.RoomType.map(item => {
              return {
                title: item.Text,
                dataIndex: item.Id,
                width: "120px",
                edit: {
                  type: "number"
                },
                min: 0,
                max: 1000000
              };
            });
            let row = {};
            res.Data.RoomType.forEach(item => {
              row[item.Id] = item.Data.Price;
            });
            this.data.push(row);
            this.dataRecord = { ...this.data[0] };
            this.loadRoomPriceTable();
            this.visible.spinning = false;
          })
          .catch(() => {
            this.visible.spinning = false;
          });
      } else {
        this.$post("PriceSystem_Get", { id: this.editId })
          .then(res => {
            this.setPriceData(res.Data);
            // this.roomPriceInfo.Code = res.Data.Code;
            // this.roomPriceInfo.Name = res.Data.Name;
            // this.roomPriceInfo.ValidStatus = res.Data.ValidStatus.toString();
            // this.roomPriceInfo.Attributes = res.Data.Attributes;
            // this.roomPriceInfo.Remark = res.Data.Remark;
            // this.roomPriceInfo.IsDefault = res.Data.IsDefault;
            // this.roomPriceInfo.IsHourRoom = res.Data.IsHourRoom;
            // this.roomPriceInfo.IsCustomerUse = res.Data.IsCustomerUse;
            // this.roomPriceInfo.IsMemberUse = res.Data.IsMemberUse;
            // this.roomPriceInfo.OffStartTime = res.Data.OffStartTime
            //   ? moment(res.Data.OffStartTime, "HH:mm")
            //   : null;
            // this.roomPriceInfo.OffEndTime = res.Data.OffEndTime
            //   ? moment(res.Data.OffEndTime, "HH:mm")
            //   : null;
            // this.roomPriceInfo.Duration = res.Data.Duration;
            // this.columns = res.Data.BasePriceDetails.map(item => {
            //   return {
            //     title: item.RoomTypeName,
            //     dataIndex: item.RoomTypeId,
            //     width: "120px",
            //     edit: {
            //       type: "number"
            //     },
            //     min: 0,
            //     max: 1000000
            //   };
            // });
            // let row = {};
            // res.Data.BasePriceDetails.forEach(item => {
            //   row[item.RoomTypeId] = item.Price;
            // });
            // this.data.push(row);
            // this.dataRecord = { ...this.data[0] };
            // this.loadRoomPriceTable();
            // this.specialPrices = res.Data.RoomTypeSpecialPrices;
            // this.updateMonthData(this.specialPrices);
            this.visible.spinning = false;
          })
          .catch(() => {
            this.visible.spinning = false;
          });
      }
    },
    setPriceData(data) {
      this.roomPriceInfo.Code = data.Code;
      this.roomPriceInfo.Name = data.Name;
      this.roomPriceInfo.ValidStatus = data.ValidStatus.toString();
      this.roomPriceInfo.Attributes = data.Attributes;
      this.roomPriceInfo.Remark = data.Remark;
      this.roomPriceInfo.IsDefault = data.IsDefault;
      this.roomPriceInfo.IsHourRoom = data.IsHourRoom;
      this.roomPriceInfo.IsCustomerUse = data.IsCustomerUse;
      this.roomPriceInfo.IsMemberUse = data.IsMemberUse;
      this.roomPriceInfo.OffStartTime = data.OffStartTime
        ? moment(data.OffStartTime, "HH:mm")
        : null;
      this.roomPriceInfo.OffEndTime = data.OffEndTime
        ? moment(data.OffEndTime, "HH:mm")
        : null;
      this.roomPriceInfo.Duration = data.Duration;
      this.columns = data.BasePriceDetails.map(item => {
        return {
          title: item.RoomTypeName,
          dataIndex: item.RoomTypeId,
          width: "120px",
          edit: {
            type: "number"
          },
          min: 0,
          max: 1000000
        };
      });
      let row = {};
      data.BasePriceDetails.forEach(item => {
        row[item.RoomTypeId] = item.Price;
      });
      this.data.push(row);
      this.dataRecord = { ...this.data[0] };
      this.loadRoomPriceTable();
      this.specialPrices = data.RoomTypeSpecialPrices;
      this.updateMonthData(this.specialPrices);
    },
    onChangeHourRoom(e) {
      this.roomPriceInfo.IsHourRoom = e.target.checked;
      if (e.target.checked) {
        this.roomPriceInfo.Duration = 3;
      } else {
        this.roomPriceInfo.Duration = 0;
      }
    },
    addSpecialRoomPrice() {
      this.visible.priceCalendarModal = true;
      this.changeSpecialColor();
      // this.onChangeMonth(0);
    },
    //初始化特殊房价表格
    loadRoomPriceTable() {
      this.MonthButtonArr = [];
      const accountDate = cache.get("user").AccountDate;
      this.MonthButtonArr = [];
      let curMon = moment(accountDate).month() + 1;
      let start = moment(accountDate).format("YYYY-MM-DD");
      let end = moment(start)
        .endOf("month")
        .format("YYYY-MM-DD");
      for (let i = 0; i < 12; i++) {
        this.MonthButtonArr.push({
          month: curMon,
          start: start,
          end: end
        });
        this.reloadData(start, end, i);
        curMon++;
        if (curMon > 12) {
          curMon = 1;
        }
        start =
          moment(start)
            .add("months", 1)
            .format("YYYY-MM") + "-01";
        end = moment(start)
          .endOf("month")
          .format("YYYY-MM-DD");
      }
      this.columnsRoomPrice = this.monthData[0].columns;
      this.dataRoomPrice = this.monthData[0].data;
      this.roomInfoParams.monthIndex = 0;
      this.tableLength = 820 + this.monthData[0].dayNum * 80;
    },
    reloadData(start, end, index) {
      const days = moment(end).diff(start, "days") + 1;
      const columns = this.createColumns(start, end, days);
      const data = this.createData(days);
      this.monthData.splice(index, 0, {
        dayNum: days, //相差天数
        startDate: start, //表格的开始日期
        endDate: end, //表格的结束日期
        data: data,
        columns: columns
      });
      this.updateMonthData(this.specialPrices);
    },
    createColumns(startDate, endDate, dayNum) {
      let columns = [
        {
          title: "房型",
          dataIndex: "text",
          width: 200,
          fixed: "left",
          align: "center"
        }
      ];

      // let dayNum = endDate.diff(startDate, "days") + 1;
      this.tableLength = 820 + dayNum * 80;
      const _this = this;
      for (let i = 0; i < dayNum; i++) {
        const date = moment(startDate).add(i, "days");
        const field = "col" + i;
        const columnItem = {
          title: date.format("MM-DD (dd)"),
          date: date.format("YYYY-MM-DD"),
          dataIndex: field,
          width: Math.round((this.tableLength - 200) / dayNum),
          align: "center",
          edit: {
            type: "number"
          },
          onChange: value => {
            const basePrice =
              _this.copyData[this.currentKey].data[this.rowIndex][field];
            const target = document
              .querySelectorAll("#roomPriceTable tr")
              [this.rowIndex + 1].querySelectorAll("td")[i + 1];
            if (basePrice != value) {
              this.$common.addClass(target, "is-changed");
            } else {
              this.$common.removeClass(target, "is-changed");
            }
          },
          customCell: (record, rowIndex) => {
            return {
              props: {},
              on: {
                click: () => {
                  this.rowIndex = rowIndex;
                },
                mouseenter: () => {}
              }
            };
          }
        };
        columns.push(columnItem);
      }
      return columns;
    },
    createData(dayNum) {
      let rows = [];
      let baseRoomTypePrice = this.data[0];
      for (let x = 0; x < this.columns.length; x++) {
        const row = {};
        //房型名称
        row["text"] = this.columns[x].title;
        row["key"] = this.columns[x].dataIndex;
        //获取对应的基础价格
        let basePrice = "";
        for (const key in baseRoomTypePrice) {
          if (key == this.columns[x].dataIndex) {
            basePrice = baseRoomTypePrice[key];
            break;
          }
        }
        //所有特殊房价设置默认基础房价  展示
        for (let i = 0; i < dayNum; i++) {
          const field = "col" + i;
          row[field] = basePrice;
        }
        rows.push(row);
      }
      return rows;
    },
    onUpdateMonthData(monthData, el, item) {
      //找到了对应的月份
      for (let index = 0; index < monthData.data.length; index++) {
        let item0 = monthData.data[index];
        if (item0.key == item.RoomTypeId) {
          //找到了对应的行 index
          for (const x in item0) {
            if (x != "text" && x != "key") {
              let num = Number(x.substr(x.indexOf("l") + 1)); //截取l 后面的数字  用来计算日期
              let date = moment(monthData.startDate)
                .add(num, "days")
                .format("YYYY-MM-DD");
              if (date == el.PriceDate) {
                //找到了那一天 则更新房价
                item0[x] = el.Price;
                break;
              }
            }
          }
          break; //找到对应的行 处理完房价就跳出
        }
      }
    },
    //批量修改 和 编辑进来的  单独更新房价日历 特殊房价
    updateMonthData(RoomTypeSpecialPrices, status) {
      RoomTypeSpecialPrices.forEach(item => {
        //特殊修改过的，找到某一天，再通过房型匹配
        item.RoomPriceDetails.forEach(el => {
          this.monthData.forEach(month => {
            const cols = month.columns;
            const list = month.data;
            const col = cols.find(ele => ele.date == el.PriceDate);
            if (col) {
              let target = list.find(dat => {
                return dat.key == item.RoomTypeId;
              });
              target[col.dataIndex] = el.Price;
            }
          });
        });
      });
      if (status != 0) {
        this.copyData = cloneDeep(this.monthData);
      }
    },
    onChangeMonth(e) {
      //切换月份 切换表格数据
      const key = e.target.value;
      this.currentKey = key;
      this.columnsRoomPrice = this.monthData[key].columns;
      this.dataRoomPrice = this.monthData[key].data;
      this.roomInfoParams.monthIndex = key;
      // this.updateMonthData(this.specialPrices);
      this.tableLength = 820 + this.monthData[key].dayNum * 80;
      this.addEditColor();
      this.changeSpecialColor();
    },
    addEditColor() {
      const _this = this;
      this.$nextTick(() => {
        this.dataRoomPrice.forEach((el, index) => {
          const copyList = _this.copyData[this.currentKey].data[index];
          for (let i in copyList) {
            let colIndex = i.split("col")[1];
            if (colIndex != undefined) {
              colIndex = Number(i.split("col")[1]);
              const target = document
                .querySelectorAll("#roomPriceTable tr")
                [index + 1].querySelectorAll("td")[colIndex + 1];
              if (el[i] != copyList[i]) {
                this.$common.addClass(target, "is-changed");
              } else {
                this.$common.removeClass(target, "is-changed");
              }
            }
          }
        });
      });
    },
    changeSpecialColor() {
      const _this = this;
      this.$nextTick(() => {
        this.dataRoomPrice.forEach((el, index) => {
          const basePrice = _this.dataRecord[el.key];
          for (let i in el) {
            if (i != "text" && i != "key") {
              let nowPrice = el[i];
              let colIndex = Number(i.split("col")[1]);
              const target = document
                .querySelectorAll("#roomPriceTable tr")
                [index + 1].querySelectorAll("td")[colIndex + 1];
              if (basePrice != nowPrice) {
                this.$common.addClass(target, "is-special");
              } else {
                this.$common.removeClass(target, "is-special");
              }
            }
          }
        });
      });
    },
    openBatchEdit() {
      if (this.prohibit) {
        this.visible.BatchEditModal = false;
      } else {
        this.visible.BatchEditModal = true;
      }
    },
    //批量编辑房价
    onBatchEdit() {
      let json = this.$refs.batchEditPrice.onSubmitBefore();
      if (json === false) return;
      const _this = this;

      _this.visible.batchConfirmLoading = true;
      json.PriceCodeId = this.editId;
      _this
        .$post("PriceSystem_GetBRP", json)
        .then(res => {
          _this.specialPrices = res.Data;
          _this.updateMonthData(res.Data, 0);
          _this.$message.info("请核对价格，点击确定后提交。");
          _this.visible.BatchEditModal = false;
          _this.visible.batchConfirmLoading = false;
          _this.addEditColor();
        })
        .catch(() => {
          _this.visible.batchConfirmLoading = false;
        });
    },
    //编辑房价
    onEditRoomPrice() {
      let roomPrice = this.$refs.editRoomPrice.getEditRoomPrice();
      if (roomPrice === false) return;
      this.visible.EditRoomPriceModal = false;
      //this.DatePrice = roomPrice;
      const monthIndex = this.roomInfoParams.monthIndex;
      const rowIndex = this.roomInfoParams.rowIndex;
      const cellIndex = this.roomInfoParams.cellIndex;
      const rowData = this.monthData[monthIndex].data[rowIndex];
      rowData[cellIndex] = roomPrice;
    },
    //修改基础房价  更新房价日历
    updateRoomPrice(key, roomPrice) {
      this.monthData.forEach(el => {
        el.data.forEach(item => {
          if (item.key == key)
            for (const x in item) {
              if (x != "text" && x != "key") item[x] = roomPrice;
            }
        });
      });
      if (this.isCoverPrice == 2) {
        this.updateMonthData(this.specialPrices);
      }
    },
    onSubmitRoomPrice() {
      //提交房价日历的数据
      this.visible.priceCalendarModal = false;
      this.onSubmit();
    },
    onCancel() {
      this.visible.priceCalendarModal = false;
      this.visible.AddModal = false;
    },
    onSubmit() {
      if (this.visible.spinning) {
        this.visible.AddModal = false;
        return;
      }
      if (
        this.roomPriceInfo.Name.trim() == "" ||
        this.roomPriceInfo.Code.trim() == ""
      ) {
        this.$message.error("请填写代码和名称！");
        return;
      }
      this.visible.confirmLoading = true;
      let json = {
        ...this.roomPriceInfo,
        OffStartTime: this.roomPriceInfo.OffStartTime
          ? moment(this.roomPriceInfo.OffStartTime).format("HH:mm")
          : "",
        OffEndTime: this.roomPriceInfo.OffEndTime
          ? moment(this.roomPriceInfo.OffEndTime).format("HH:mm")
          : "",
        BasePriceDetails: [],
        RoomPriceDetails: []
      };
      for (const key in this.dataRecord) {
        // 630217353539358720: "500.00"
        json.BasePriceDetails.push({
          RoomTypeId: key,
          RoomTypeName: "cjn",
          Price: this.dataRecord[key]
        });
      }
      //col18: "200.00",col19: "200.00",key: "630217353539358720",text: "标准双人间"
      this.monthData.forEach(el => {
        el.data.forEach(item => {
          const room = json.BasePriceDetails.find(
            ele => ele.RoomTypeId == item.key
          );
          for (const x in item) {
            if (x != "text" && x != "key") {
              let num = Number(x.substr(x.indexOf("l") + 1)); //截取l 后面的数字  用来计算日期
              //只对房价处理
              if (Number(room.Price) != Number(item[x])) {
                json.RoomPriceDetails.push({
                  RoomTypeId: item.key,
                  RoomTypeName: item.text,
                  PriceDate: moment(el.startDate)
                    .add(num, "days")
                    .format("YYYY-MM-DD"), //col0  dayNum
                  Price: item[x]
                });
              }
            }
          }
        });
      });
      if (this.editId == "") {
        this.$post("PriceSystem_Add", json)
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            this.$message.info("新增成功！");
            this.visible.confirmLoading = false;
            this.visible.AddModal = false;
            this.$parent.reload();
          })
          .catch(() => {
            this.visible.confirmLoading = false;
          });
      } else {
        json.Id = this.editId;
        const _this = this;
        this.$post("PriceSystem_Edit", json, { alertError: false })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            this.$message.success("修改成功！");
            this.visible.confirmLoading = false;
            this.visible.AddModal = false;
            this.$parent.reload();
          })
          .catch(error => {
            if (error.data.Code == -1) {
              _this.$confirm({
                title: error.data.Message + ",是否继续？",
                onOk() {
                  json.KeyWord = "Y";
                  _this.visible.confirmLoading = true;
                  _this
                    .$post("PriceSystem_Edit", json)
                    .then(() => {
                      _this.$message.success("修改成功！");
                      _this.visible.confirmLoading = false;
                      _this.visible.AddModal = false;
                      _this.$parent.reload();
                    })
                    .catch(() => {
                      _this.visible.confirmLoading = false;
                    });
                },
                onCancel() {
                  _this.visible.confirmLoading = false;
                }
              });
            } else {
              this.$message.error(error.data.Message);
              this.visible.confirmLoading = false;
              return;
            }
          });
      }
    }
  },
  watch: {
    data() {
      if (this.data && this.data.length > 0) {
        let newData = this.data[0];
        for (const key in newData) {
          if (this.dataRecord[key] != newData[key]) {
            const roomPrice = newData[key];
            this.updateRoomPrice(key, roomPrice);
            this.dataRecord = { ...this.data[0] };
            break;
          }
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.room-table /deep/.ant-table-body {
  overflow-y: hidden;
}
table {
  width: 100%;
  text-align: left;
  overflow: hidden;
  tr {
    td {
      width: 25%;
      padding: 2px;
      text-align: left;
      height: 36px;
      span.label-txt {
        display: inline-block;
        width: 75px;
        text-align: justify;
        text-align-last: justify;
        padding-left: 5px;
        position: relative;
        padding-right: 10px;
        &::after {
          content: "：";
          position: absolute;
          right: -5px;
          top: 0;
        }
      }
      .time {
        width: 195px;
        padding-left: 0;
      }
      input {
        width: 140px;
      }
    }
  }
}

#roomPriceTable /deep/ .is-changed .data-grid-cell-edit .text-wrapper {
  color: #f00;
  font-weight: bold;
}
#roomPriceTable /deep/ .ant-table-tbody > tr > td.is-special {
  // background: #ecfbff;
  // color: #079db0;
  // font-weight: bold;
  background: #f8fdff;
  color: #00b1c7;
}
#roomPriceTable /deep/.data-grid-cell-edit,
.room-table /deep/.data-grid-cell-edit {
  margin: 0;
}
</style>
